import React, { useState, useEffect } from 'react';

/**
 * SearchableDropdown
 * Props:
 * - options: array of { value, label }
 * - value: selected value
 * - onChange: function(value)
 * - placeholder: string
 * - required: boolean
 * - name: string (for react-hook-form)
 */
const SearchableDropdown = ({ options = [], value, onChange, placeholder = '', required = false, name }) => {
  const [search, setSearch] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const [filtered, setFiltered] = useState(options);

  useEffect(() => {
    if (search.trim() === '') {
      setFiltered(options);
    } else {
      setFiltered(
        options.filter(opt =>
          opt.label.toLowerCase().includes(search.trim().toLowerCase())
        )
      );
    }
  }, [search, options]);

  const handleSelect = (val) => {
    onChange(val);
    setShowOptions(false);
    setSearch('');
  };

  const selectedLabel = options.find(opt => opt.value === value)?.label || '';

  return (
    <div className="relative w-full">
      <div className="relative">
        <input
          type="text"
          className="outline-none border-2 border-secondary-500 rounded-lg text-black w-full pr-10 px-3 py-2"
          placeholder={placeholder}
          value={showOptions ? search : selectedLabel}
          onFocus={() => setShowOptions(true)}
          onChange={e => {
            setSearch(e.target.value);
            setShowOptions(true);
          }}
          required={required}
          name={name}
          autoComplete="off"
          readOnly={!showOptions}
        />
        {/* Dropdown icon only */}
        <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
          <svg width="20" height="20" fill="none" viewBox="0 0 20 20">
            <path d="M6 8l4 4 4-4" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </div>
      {showOptions && (
        <div className="absolute z-10 bg-white border-2 border-secondary-500 rounded-lg mt-1 w-full max-h-48 overflow-y-auto shadow-lg">
          {filtered.length === 0 ? (
            <div className="px-3 py-2 text-gray-400">No results</div>
          ) : (
            filtered.map(opt => (
              <div
                key={opt.value}
                className={`px-3 py-2 cursor-pointer hover:bg-secondary-100 ${opt.value === value ? 'bg-secondary-200' : ''}`}
                onMouseDown={() => handleSelect(opt.value)}
              >
                {opt.label}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
